import { StocksExchangeCheckoutAction } from './stocks-exchange-checkout.action';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, pipe } from 'rxjs';
import { withLatestFrom, map, filter, exhaustMap, switchMap, catchError, share } from 'rxjs/operators';

import { BackendService } from '@toro/common/shared/services/backend/backend.service';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { DefaultResponse } from '@toro/common/shared/models/form/DefaultResponse';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
@Injectable()
export class StocksExchangeCheckoutEffects {

    /**
     * Criar uma nova ordem de cliente
     */
    @Effect()
    public newOrder$: Observable<StocksExchangeCheckoutAction> = this.actions$
      .pipe(
        ofType(StocksExchangeCheckoutAction.newOrder),
        withLatestFrom(this.store$.select((s) => s.authentication)),
        filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
        exhaustMap(([action, auth]) => {
            return this.backendService.post<DefaultResponse>(RoutesTable.exchange.routes.newOrder.uri, action.payload.data, action.payload.token)
                .map((result) => {
                    if (result.ok) {
                        return { type: StocksExchangeCheckoutAction.newOrderSuccess, payload: result.value };
                    }
                    return { type: StocksExchangeCheckoutAction.newOrderError, payload: result.value };
                })
                .catch((error) => {
                    return Observable.of({ type: StocksExchangeCheckoutAction.newOrderError, payload: error });
                });
            },
        ),
        share());

    /**
     * Editar uma ordem de cliente
     */
    @Effect()
    public editOrder$: Observable<StocksExchangeCheckoutAction> = this.actions$
    .pipe(
    ofType(StocksExchangeCheckoutAction.editOrder),
    withLatestFrom(this.store$.select((s) => s.authentication)),
    filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
    switchMap(([action, auth]) => {
        return this.backendService.post<DefaultResponse>(RoutesTable.exchange.routes.editOrder.uri, action.payload.data, action.payload.token)
            .map((result) => {
                if (result.ok) {
                    return { type: StocksExchangeCheckoutAction.editOrderSuccess, payload: result.value };
                }
                return { type: StocksExchangeCheckoutAction.editOrderError, payload: result.value };
            })
            .catch((error) => {
                return Observable.of({ type: StocksExchangeCheckoutAction.editOrderError, payload: error });
            });
        },
    ),
    share());

    /**
     * Criar uma nova ordem de cliente
     */
    @Effect()
    public newStrategy$: Observable<StocksExchangeCheckoutAction> = this.actions$
      .pipe(
        ofType(StocksExchangeCheckoutAction.newStrategy),
        withLatestFrom(this.store$.select((s) => s.authentication)),
        filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
        switchMap(([action, auth]) => {
            return this.backendService.post<DefaultResponse>
                (RoutesTable.exchange.routes.newStrategy.uri, action.payload.data, action.payload.token )
                .map((result) => {
                    if (result.ok) {
                        return { type: StocksExchangeCheckoutAction.newStrategySuccess, payload: result.value };
                    }
                    return { type: StocksExchangeCheckoutAction.newStrategyError, payload: result.value };
                })
                .catch((error) => {
                    return Observable.of({ type: StocksExchangeCheckoutAction.newStrategyError, payload: error });
                });
            },
        ),
        share());

    /**
     * Editar uma nova ordem de cliente
     */
    @Effect()
    public editStrategy$: Observable<StocksExchangeCheckoutAction> = this.actions$
        .pipe(
        ofType(StocksExchangeCheckoutAction.editStrategy),
        withLatestFrom(this.store$.select((s) => s.authentication)),
        filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
        switchMap(([action, auth]) => {
            return this.backendService.post<DefaultResponse>
                (RoutesTable.exchange.routes.editStrategy.uri, action.payload.data, action.payload.token )
                .map((result) => {
                    if (result.ok) {
                        return { type: StocksExchangeCheckoutAction.editStrategySuccess, payload: result.value };
                    }
                    return { type: StocksExchangeCheckoutAction.editStrategyError, payload: result.value };
                })
                .catch((error) => {
                    return Observable.of({ type: StocksExchangeCheckoutAction.editStrategyError, payload: error });
                });
            },
        ),
        share());

    /**
     * Criar uma nova ordem de cliente
     */
    @Effect()
    public shutDownStrategy$: Observable<StocksExchangeCheckoutAction> = this.actions$
      .pipe(
        ofType(StocksExchangeCheckoutAction.shutDownStrategy),
        withLatestFrom(this.store$.select((s) => s.authentication)),
        filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
        switchMap(([action, auth]) => {
            return this.backendService.post<DefaultResponse>
            (RoutesTable.exchange.routes.shutDownStrategy.uri, action.payload, action.payload.token )
                .map((result) => {
                    if (result.ok) {
                        return { type: StocksExchangeCheckoutAction.shutDownStrategySuccess, payload: result.value };
                    }
                    return { type: StocksExchangeCheckoutAction.shutDownStrategyError, payload: result.value };
                })
                .catch((error) => {
                    return Observable.of({ type: StocksExchangeCheckoutAction.shutDownStrategyError, payload: error });
                });
            },
        ),
        share());

    /**
     * Obtém os próximos dias úteis
     */
    @Effect()
    public nextWorkingDay$: Observable<StocksExchangeCheckoutAction> = this.actions$
      .pipe(
        ofType(StocksExchangeCheckoutAction.nextWorkingDays),
        switchMap((action) => {

            const currentDate = new Date();
            const currentDateString = currentDate
                .toISOString()
                .split('T')[0]
                .split('-');

            const endDate = new Date();
            endDate.setFullYear((+currentDate.getFullYear()) + 1);
            const endDateString = endDate
                .toISOString()
                .split('T')[0]
                .split('-');

            const today = `${currentDateString[0]}/${currentDateString[1]}/${currentDateString[2]}`;
            const end = `${endDateString[0]}/${endDateString[1]}/${endDateString[2]}`;

            const url = RoutesTable.composeUri(RoutesTable.corporation.routes.getWorkingDaysBovespa, today, end);

            return this.backendService.get<DefaultResponse>(url)
                .map((result) => {
                    if (result.ok) {
                        return { type: StocksExchangeCheckoutAction.nextWorkingDaysSuccess, payload: result.value };
                    }
                    return { type: StocksExchangeCheckoutAction.nextWorkingDaysError, payload: result.value };
                })
                .catch((error) => {
                    return Observable.of({ type: StocksExchangeCheckoutAction.nextWorkingDaysError, payload: error });
                });
            },
        ),
        share());

        constructor(
            private actions$: Actions<StocksExchangeCheckoutAction>,
            private backendService: BackendService,
            private store$: Store<AppState>,
        ) { }
}
